// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_f7-0";
export var fulfillmentPanelBody = "_f7-1";